import React, { useState, useEffect, useCallback } from "react";
import { FiSearch, FiPlus } from "react-icons/fi";
import { Check, X as CloseIcon, Edit2 } from "lucide-react";
import SelectRangeButton from "../common/select-range-button.jsx";
import ContactModal from "./contact-modal.jsx";
import { deleteContactApi, getContactListApi } from "./vendor_api";
import { ReactComponent as EmailIc } from "../../assets/svg/contact_email_ic.svg";
import { ReactComponent as PhoneIc } from "../../assets/svg/cont_phone_ic.svg";
import { ReactComponent as YesIcon } from "../../assets/svg/notify_crt_ic.svg";
import { ReactComponent as WrongIcon } from "../../assets/svg/notify_wrg_ic.svg";
import { ReactComponent as EditIc } from "../../assets/svg/edit_ic.svg";
import { ReactComponent as DeleteIc } from "../../assets/svg/delete_ic.svg";
import "./vendorView.css";
import ReactPaginate from "react-paginate";
import { Dropdown } from "react-bootstrap";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { format } from "date-fns";
import DeleteModal from "../common/deleteModel.js";
const ContactTab = ({ vendorId, onShowSnackbar }) => {
  const [isOpenContact, setIsOpenContact] = useState(false);
  const [selectedContact, setSelectedContact] = useState(null);
  const [dateRange, setDateRange] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    if (selectedContact) {
      setIsOpenContact(true);
    }
  }, [selectedContact]);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [search, setSearch] = useState("");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);
  const getContactList = async () => {
    const start = dateRange?.start;
    const end = dateRange?.end;

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    try {
      const param = {
        limit: itemsPerPage,
        skip: itemOffset * itemsPerPage,
        search: search,
        from_date: formattedStart,
        to_date: formattedEnd,
      };
      const response = await getContactListApi(vendorId, param);
      if (response.data.success === true) {
        const fetchedProject = response.data.contacts ?? [];
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setContacts(fetchedProject);
      }
    } catch (err) {
    } finally {
    }
  };

  useEffect(() => {
    getContactList();
  }, [itemsPerPage, dateRange, itemOffset, search]);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const deleteContact = async () => {
    // setIsLoading(true);
    try {
      const response = await deleteContactApi(deleteId);
      console.log("response....", response);
      if (response.data.success === true) {
        getContactList();
        onShowSnackbar(response.data.message ?? "", response.data.success);

        setDeleteId(null);
        setIsOpenDelete(false);
      } else {
        onShowSnackbar(response.data.message ?? "", response.data.success);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      //   setIsLoading(false);
    }
  };
  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  return (
    <div>
      <DeleteModal
        title={"contact"}
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteContact}
      />
      <div className="header-bar">
        {/* Left */}
        <div className="header-left">
          <span className="fs-16 fw-600 textcolor">
            Contacts - {totalCount}
          </span>
        </div>

        {/* Right */}
        <div className="header-right">
          <div className="header-center">
            <FiSearch className="search-icon" />
            <input
              type="text"
              placeholder="Search..."
              className="search-input"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <button
            className="contact-new-btn"
            onClick={() => setIsOpenContact(true)}
          >
            <FiPlus size={16} />
            <span>New</span>
          </button>

          <SelectRangeButton
            onChange={(range) => {
              setDateRange(range);
            }}
          />
        </div>
      </div>

      {/* Contacts Table */}
      <div style={{ marginTop: "20px" }}>
        <table className="contact-table">
          <thead>
            <tr>
              <th>Contact name</th>
              <th>Title</th>
              <th>Email</th>
              <th>Mobile number</th>
              <th>Notify</th>
            </tr>
          </thead>

          <tbody>
            {contacts.map((contact, index) => (
              <tr
                key={contact.id}
                style={{
                  cursor: "pointer",
                }}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
              >
                <td className="fs-14 fw-500 textcolor">{contact.name}</td>
                <td className="fs-14 fw-500 textcolor">{contact.title}</td>

                <td className="muted">
                  <div className="cell-flex">
                    <EmailIc />
                    <span className="fs-14 fw-500 textcolor">
                      {contact.email}
                    </span>
                  </div>
                </td>

                <td className="muted">
                  <div className="cell-flex">
                    <PhoneIc />
                    <span className="fs-14 fw-500 textcolor">
                      {" "}
                      {contact.phone}
                    </span>
                  </div>
                </td>

                <td>
                  {contact.vendor_notify ? (
                    <span className="fs-14 fw-500 textcolor">
                      {" "}
                      <YesIcon /> Yes
                    </span>
                  ) : (
                    <span className="fs-14 fw-500 textcolor">
                      <WrongIcon /> No
                    </span>
                  )}
                </td>
                {hoveredIndex === index && (
                  <div className="row-actions ">
                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        setSelectedContact(contact);
                      }}
                      className="action-btn"
                    >
                      <EditIc />
                    </div>

                    <div
                      onClick={(e) => {
                        e.stopPropagation();
                        setDeleteId(contact.id);
                      }}
                      className="action-btn"
                    >
                      <DeleteIc />
                    </div>
                  </div>
                )}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Pagination */}
        <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
          <Dropdown>
            <span className="fs-13 fw-500 textdrkColor">
              Records per page: &nbsp;
            </span>
            <Dropdown.Toggle
              id="dropdown-pagination"
              className="bg-transparent pagination-color border-0 custom-dropdown-toggle p-0"
              style={{
                outline: "none",
                boxShadow: "none",
              }}
            >
              <span
                className="bg-white textcolor no-of-rows rounded-3 px-2 py-2"
                style={{
                  border: "1px solid #EBEBEB",
                  transition: "all 0.2s ease-in-out",
                  display: "inline-block",
                }}
              >
                {itemsPerPage} <DownArrowIc />
              </span>
            </Dropdown.Toggle>
            <Dropdown.Menu
              className="my-2"
              style={{ minWidth: "unset", width: "30%" }}
            >
              {[5, 10, 25, 50, 75, 100].map((size) => (
                <Dropdown.Item
                  key={size}
                  onClick={() => {
                    setItemsPerPage(size);
                  }}
                  active={itemsPerPage === size}
                  className="text-center"
                >
                  {size}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>

          <div className="d-flex align-items-center gap-2">
            <ReactPaginate
              previousLabel={
                <div
                  className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "32px",
                    height: "32px",
                  }}
                >
                  <LarIc />
                </div>
              }
              nextLabel={
                <div
                  className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                  style={{
                    width: "32px",
                    height: "32px",
                  }}
                >
                  <RarIc />
                </div>
              }
              breakLabel={"..."}
              pageCount={pageCount + 1}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
            />
          </div>
        </div>
      </div>

      {/* Contact Modal */}
      {isOpenContact && (
        <ContactModal
          vendorId={vendorId}
          contact={selectedContact}
          onClose={() => {
            setIsOpenContact(false);
            setSelectedContact(null);
          }}
          onSuccess={(response) => {
            setIsOpenContact(false);
            setSelectedContact(null);
            if (onShowSnackbar) {
              getContactList();
              onShowSnackbar(
                selectedContact
                  ? "Contact updated successfully"
                  : response?.data?.message || "Contact saved successfully",
                true,
              );
            }
          }}
        />
      )}
    </div>
  );
};

export default ContactTab;
